"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const kebabCase_1 = __importDefault(require("lodash/kebabCase"));
const HelperUtils_1 = require("utils/HelperUtils");
const TooltipPortal_1 = __importDefault(require("components/shared/Tooltips/TooltipPortal"));
const CircleComponent_1 = __importDefault(require("./CircleComponent"));
const ListDataVerticalSteps = ({ steps, step, index, activeStep, setActiveStep }) => {
    const [portalData, setPortalData] = (0, react_1.useState)({});
    const [isEllipsis, setIsEllipsis] = (0, react_1.useState)(false);
    const [isTooltipShown, setIsTooltipShown] = (0, react_1.useState)(false);
    const setPortal = (step, index) => {
        if (isEllipsis) {
            setIsTooltipShown(true);
            const rowPosition = document.getElementById(`row-position-${index}`);
            setPortalData({
                name: step === null || step === void 0 ? void 0 : step.name,
                left: (rowPosition === null || rowPosition === void 0 ? void 0 : rowPosition.getBoundingClientRect().left) || 0 + 208 + 'px',
                top: (rowPosition === null || rowPosition === void 0 ? void 0 : rowPosition.getBoundingClientRect().top) || 0 + -5 + 'px',
                noWrap: true
            });
        }
    };
    let circleColor;
    let nameColor = '';
    if (activeStep.toLowerCase() === step.name.toLowerCase()) {
        circleColor = 'var(--base-600)';
        nameColor = 'text-base-600';
    }
    else if (step.disabled) {
        circleColor = 'var(--n-600)';
        nameColor = 'text-n-600';
    }
    else if (step.completed) {
        circleColor = 'var(--base-600)';
        nameColor = '';
    }
    else {
        circleColor = 'var(--n-600)';
        nameColor = '';
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { id: `row-position-${index}`, key: index, className: `step-container ${step.disabled ? 'cursor-not-allowed' : ''}`, onClick: (e) => {
                e === null || e === void 0 ? void 0 : e.stopPropagation();
                if (!step.disabled) {
                    setActiveStep(step.name);
                }
            }, onMouseOver: () => setPortal(step, index), onMouseOut: () => setIsTooltipShown(false), "data-cy": `step-${(0, kebabCase_1.default)(step.name)}` },
            react_1.default.createElement(CircleComponent_1.default, { containerClass: "custom-circle-container", backgroundColor: circleColor, borderColor: circleColor, pointerEvent: step.disabled ? 'cursor-not-allowed' : '', isChecked: true }, step.completed ? (react_1.default.createElement("i", { className: `material-icons text-n-000 fs-16` }, "check")) : (react_1.default.createElement("span", { className: `text-n-000 fs-14` }, index + 1))),
            (step === null || step === void 0 ? void 0 : step.name.length) > 21 && (react_1.default.createElement(TooltipPortal_1.default, { show: isTooltipShown, portalData: portalData, portalId: 'shared-tooltip' })),
            react_1.default.createElement("p", { ref: (ref) => (ref === null || ref === void 0 ? void 0 : ref.offsetWidth) &&
                    (ref === null || ref === void 0 ? void 0 : ref.scrollWidth) &&
                    setIsEllipsis((ref === null || ref === void 0 ? void 0 : ref.offsetWidth) < (ref === null || ref === void 0 ? void 0 : ref.scrollWidth)), className: `typography-h400 ml-[16px] mb-[0px] truncate ${nameColor}` }, (0, HelperUtils_1.getObjectiveLocale)(step.name))),
        index !== (steps === null || steps === void 0 ? void 0 : steps.length) - 1 && react_1.default.createElement("div", { className: 'divider-steps' })));
};
exports.default = ListDataVerticalSteps;
